import { useCallback } from 'react';
import { IHandleCleanupParams, TInputState } from '../types';
import { reduce } from 'lodash';
import { THandleCleanup } from './types';

export const useHandleCleanup = ({
  inputs,
  setInputs,
}: IHandleCleanupParams): THandleCleanup => {
  return useCallback(() => {
    setInputs(
      reduce(
        inputs,
        (r, v, k) => ({
          ...r,
          [k]: { ...v, value: undefined, touched: false, errors: undefined },
        }),
        {} as Record<string, TInputState>
      )
    );
  }, [inputs, setInputs]);
};
